module.exports = __webpack_public_path__ + "img/202412_skinmask_voice.78693b9c.jpg";